var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 8C8 10.206 9.79395 12 12 12C14.2061 12 16 10.206 16 8C16 5.79401 14.2061 4 12 4C9.79395 4 8 5.79401 8 8ZM10 8C10 6.896 10.897 6 12 6C13.103 6 14 6.896 14 8C14 9.103 13.103 10 12 10C10.897 10 10 9.103 10 8Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 20C4.22388 20 4 19.7761 4 19.5V19C4 15.467 7.29004 13 12 13C16.71 13 20 15.467 20 19V19.5C20 19.7761 19.7761 20 19.5 20H4.5ZM17.842 18H6.15906C6.75708 16.192 8.99304 15 12.0011 15C15.009 15 17.244 16.192 17.842 18Z",
  fill: "#000"
})));
export default SvgUser;